module.exports = __webpack_public_path__ + "img/gps_off.3dfcaab4.svg";